import React from 'react';
import { SearchResultCard, Button, Chip } from '@origo/origo-ui';
import type { PlanSummary } from '../../../types';
import styles from './PlanResultCard.module.css';

interface PlanResultCardProps {
    plan: PlanSummary;
    /** Ferdig oversatt undertittel («Sist endret …»). */
    subtitle?: string;
    /** Ferdig oversatt tekst på «Velg»-knappen. */
    selectLabel: string;
    /** Ferdig oversatt tekst på «Ikke gjeldende»-chipen. */
    ikkeGjeldendeLabel: string;
    /** Klikk på kort = zoom kartet til planen. Drømmeplan-admin-mønster. */
    onZoomTo: (id: string) => void;
    /** Klikk på "Velg" = gå inn i planregistreringsflyten for planen. */
    onSelect: (id: string) => void;
}

/**
 * Memoisert og uten egen `useTranslation()` — tekstene oversettes i forelderen,
 * så antall i18next-subscriptions ikke vokser med antall rader (#14578).
 */
const PlanResultCard: React.FC<PlanResultCardProps> = ({ plan, subtitle, selectLabel, ikkeGjeldendeLabel, onZoomTo, onSelect }) => {
    // Bare første badge (plantype) vises i status-slot, så kortet holdes
    // ryddig. En plan som ikke gjelder får i tillegg «Ikke gjeldende» (AK 6.6).
    const primaryBadge = plan.badges?.[0];
    const status = primaryBadge || plan.ikkeGjeldende ? (
        <span className={styles.statuses}>
            {primaryBadge && <Chip variant={primaryBadge.variant ?? 'default'}>{primaryBadge.label}</Chip>}
            {plan.ikkeGjeldende && <Chip variant="warning">{ikkeGjeldendeLabel}</Chip>}
        </span>
    ) : undefined;

    return (
        <SearchResultCard
            title={plan.plannavn}
            subtitle={subtitle}
            status={status}
            onClick={() => onZoomTo(plan.nasjonalArealplanId)}
            secondaryAction={
                <Button
                    variant="primary"
                    size="md"
                    onClick={() => onSelect(plan.nasjonalArealplanId)}
                >
                    {selectLabel}
                </Button>
            }
        />
    );
};

export default React.memo(PlanResultCard);
